import { PartnerLayout, PartnerOrganization } from '../types';

export const layoutPerPartners: Record<string, PartnerLayout> = {
  // mirrors
  [PartnerOrganization.HELIX]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_CONE]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_HEALTH_PARTNERS]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_MEMORIAL_HERMANN]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_MYRTLE]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_MUSC]: PartnerLayout.LAYOUT_1,
  [PartnerOrganization.HELIX_RENOWN]: PartnerLayout.LAYOUT_2,
  [PartnerOrganization.HELIX_SANFORD]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_WELLSPAN]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_OSUWMC]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_NEBRASKA]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_WAKEMED]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HELIX_TRIHEALTH]: PartnerLayout.LAYOUT_3,
  // partner
  [PartnerOrganization.CONE]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.HEALTH_PARTNERS]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.MEMORIAL_HERMANN]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.MYRTLE]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.MUSC]: PartnerLayout.LAYOUT_1,
  [PartnerOrganization.RENOWN]: PartnerLayout.LAYOUT_2,
  [PartnerOrganization.SANFORD]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.WELLSPAN]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.OSUWMC]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.NEBRASKA]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.WAKEMED]: PartnerLayout.LAYOUT_3,
  [PartnerOrganization.TRIHEALTH]: PartnerLayout.LAYOUT_3,
};

export const partnerDisplayNames: Record<any, string> = {
  [PartnerOrganization.CONE]: 'Cone Health',
  [PartnerOrganization.MEMORIAL_HERMANN]: 'MHHS',
  [PartnerOrganization.MUSC]: 'MUSC',
  [PartnerOrganization.SANFORD]: 'Sanford Health',
  [PartnerOrganization.WELLSPAN]: 'WellSpan',
  [PartnerOrganization.OSUWMC]: 'OSUWMC',
  [PartnerOrganization.NEBRASKA]: 'Nebraska Medicine',
  [PartnerOrganization.WAKEMED]: 'WakeMed',
  [PartnerOrganization.TRIHEALTH]: 'TriHealth',
};

export const ssoUserPartners = [
  PartnerOrganization.CONE,
  PartnerOrganization.SANFORD,
  PartnerOrganization.WELLSPAN,
  PartnerOrganization.HELIX_WELLSPAN,
  PartnerOrganization.MEMORIAL_HERMANN,
  PartnerOrganization.HELIX_MEMORIAL_HERMANN,
  PartnerOrganization.ST_LUKE,
  PartnerOrganization.HELIX_ST_LUKE,
  PartnerOrganization.RENOWN,
  PartnerOrganization.HEALTH_PARTNERS,
  PartnerOrganization.NEBRASKA,
  PartnerOrganization.HELIX_NEBRASKA,
  PartnerOrganization.OSUWMC,
  PartnerOrganization.WAKEMED,
  PartnerOrganization.TRIHEALTH,
  PartnerOrganization.HELIX_TRIHEALTH,
];
